import map from 'lodash/map'
import React, { FC, useContext } from 'react'

import { Link } from '@Components/Link'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'

import { CollectionItem } from './CollectionItem'
import styles from './GetInspired.module.scss'

export const GetInspired: FC<{ largeImages?: boolean }> = ({ largeImages }) => {
  const { t } = useTranslation()
  const { cmsData, storeURL } = useContext(MetadataContext)

  return (
    <div className={styles.getInspiredContainer}>
      <span className={styles.sectionTitle}>{t('sidebar:HEADER_MOBILE_MENU_GET_INSPIRED')}</span>
      <div>
        {map(cmsData?.latestCollections || [], collection => (
          <CollectionItem
            key={collection.id}
            brand={collection.brand || undefined}
            id={collection.id || ''}
            imageURL={collection.image?.url || ''}
            large={largeImages}
            link={collection.url || ''}
            title={collection.title || ''}
          />
        ))}
      </div>
      <Link
        analytics={{
          dest_page_type: 'cms-category-collections',
          dest_page_type_id: '',
          source_id: 'side_bar',
        }}
        className={styles.allCollections}
        href={storeURL('collections')}
      >
        {t('sidebar:SEE_ALL_COLLECTIONS')}
      </Link>
    </div>
  )
}
